const { hot } = require("react-hot-loader/root")

// prefer default export if available
const preferDefault = m => (m && m.default) || m


exports.components = {
  "component---cache-dev-404-page-js": hot(preferDefault(require("/app/.cache/dev-404-page.js"))),
  "component---src-pages-404-js": hot(preferDefault(require("/app/src/pages/404.js"))),
  "component---src-pages-about-js": hot(preferDefault(require("/app/src/pages/about.js"))),
  "component---src-pages-app-js": hot(preferDefault(require("/app/src/pages/app.js"))),
  "component---src-pages-certificate-js": hot(preferDefault(require("/app/src/pages/certificate.js"))),
  "component---src-pages-contact-js": hot(preferDefault(require("/app/src/pages/contact.js"))),
  "component---src-pages-forgotten-password-js": hot(preferDefault(require("/app/src/pages/forgotten-password.js"))),
  "component---src-pages-index-js": hot(preferDefault(require("/app/src/pages/index.js"))),
  "component---src-pages-jobs-js": hot(preferDefault(require("/app/src/pages/jobs.js"))),
  "component---src-pages-login-js": hot(preferDefault(require("/app/src/pages/login.js"))),
  "component---src-pages-new-password-js": hot(preferDefault(require("/app/src/pages/new-password.js"))),
  "component---src-pages-pricing-js": hot(preferDefault(require("/app/src/pages/pricing.js"))),
  "component---src-pages-privacy-policy-js": hot(preferDefault(require("/app/src/pages/privacy-policy.js"))),
  "component---src-pages-register-js": hot(preferDefault(require("/app/src/pages/register.js"))),
  "component---src-pages-regulations-js": hot(preferDefault(require("/app/src/pages/regulations.js")))
}

